export const reportReducer = (
	state = {
		list: undefined,
		count: 0,
		reportData: [],
		athletesReportData: [],
		athletesCount: 0,
		reportDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "REPORT_LIST_SUCCESS":
		case "REPORT_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				reportData: action.payload.reportData,
			};
		case "ATHLETES_REPORT_LIST_SUCCESS":
		case "ATHLETES_REPORT_SEARCH_SUCCESS":
			return {
				...state,
				athletesReportData: action.payload.list,
				athletesCount: action.payload.count,
				// athletesReportData: action.payload.reportData,
			};

		case "REPORT_DETAILS":
			return {
				...state,
				reportDetails: action.payload,
			};

		case "REPORT_TOGGLE_SUCCESS":
			return {
				...state,
				reportDetails: { ...state?.reportDetails, isActive: !state?.reportDetails?.isActive },
			};
		case "REPORT_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
